<template>
    <button @click="mute" id="MuteButton" >
        <img src="@/assets/img/ui/volume-none.svg" v-if="isMuted">
        <img src="@/assets/img/ui/volume-loud.svg" v-else>
    </button>
</template>
<script>
export default {
    methods: {
        mute() {
            this.$store.commit('toggleMute');
        }
    },
    computed: {
        isMuted() {
            return this.$store.getters.getIsMuted;
        },
        contentComponentOpen() {
            return this.$store.getters.getContentComponentOpen;
        }
    }
}
</script>

<style lang="scss" scoped>
#MuteButton {
    position: absolute;
    right: 160px;
    bottom: 25px;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background: var(--main-color);
    display: flex;
    justify-content: center;

    img {
        width: 24px;
    }
}

.MuteButton--inactive {
    opacity: 0.5;
    pointer-events: none !important;

    * {
        pointer-events: none !important;
    }
}
</style>